module.exports = __webpack_public_path__ + "static/media/22ESCWA23.a455b469.jpg";